module.exports = __webpack_public_path__ + "static/media/04.61f0355e.png";